import { useMemo } from 'react'
import { useQueryTraceKeys } from '../api/useQueryTraceKeys'

export const useSelectedTraceKeyName = (traceKeyId?: number): string => {
  const { data: traceKeys } = useQueryTraceKeys()

  return useMemo(() => {
    if (!traceKeyId || !traceKeys) return ''
    return traceKeys.find(tk => tk.id === traceKeyId)?.name || ''
  }, [traceKeyId, traceKeys])
}
